import { useEffect, useMemo } from "react";
import { useMediaQuery } from "react-responsive";

import { store } from "store";
import { setDefaultIsDark } from "store/auth";

export function useColorScheme(): {
  currentIsDark: boolean;
  isDark: boolean | undefined;
  setIsDark: (value: boolean | undefined) => void;
} {
  const isDark = store.getState().authState.isDark;
  const setIsDark = (value: boolean | undefined) => store.dispatch(setDefaultIsDark(value));

  const systemPrefersDark = useMediaQuery(
    {
      query: "(prefers-color-scheme: dark)"
    },
    undefined
  );

  const value = useMemo(
    () => (isDark === undefined ? !!systemPrefersDark : isDark),
    [isDark, systemPrefersDark]
  );

  useEffect(() => {
    if (value) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [value]);

  return { currentIsDark: value, isDark, setIsDark };
}
